import { Fragment, useContext } from "react"
import { ContextualSidebarContext } from "@context"
import { Dialog, Transition } from "@headlessui/react"
import { XMarkIcon } from "@heroicons/react/24/outline"

const ContextualSidebar = () => {
  const { contextualSidebar, open, setOpen } = useContext(ContextualSidebarContext)

  return (
    <Transition.Root show={open} as={Fragment}>
      <Dialog as="div" className="relative z-[70]" onClose={() => setOpen(false)}>
        <div className="fixed inset-0" />

        <div className="fixed inset-0 overflow-hidden">
          <div className="absolute inset-0 overflow-hidden">
            <div className="fixed inset-y-0 right-0 flex max-w-full pl-10 pointer-events-none">
              <Transition.Child
                as={Fragment}
                enter="transform transition ease-in-out duration-500 sm:duration-700"
                enterFrom="translate-x-full"
                enterTo="translate-x-0"
                leave="transform transition ease-in-out duration-500 sm:duration-700"
                leaveFrom="translate-x-0"
                leaveTo="translate-x-full"
              >
                <Dialog.Panel className={`pointer-events-auto w-screen max-w-${contextualSidebar.size} shadow-lg`}>
                  <div className="flex flex-col h-full overflow-x-hidden overflow-y-scroll shadow-xl bg-content1">
                    <div className="px-4 py-6 bg-indigo-800 sm:px-6">
                      <div className="flex items-center justify-between">
                        <Dialog.Title className="text-xl font-semibold leading-6 text-white">
                          {contextualSidebar.title}
                        </Dialog.Title>
                        <div className="flex items-center ml-3 h-7">
                          <button
                            type="button"
                            className="relative text-indigo-200 bg-indigo-800 rounded-md hover:text-white focus:outline-none"
                            onClick={() => setOpen(false)}
                          >
                            <span className="absolute -inset-2.5" />
                            <span className="sr-only">Close panel</span>
                            <XMarkIcon className="w-6 h-6" aria-hidden="true" />
                          </button>
                        </div>
                      </div>

                      <div className="mt-1">
                        <p className="text-indigo-300 text-md">{contextualSidebar.subTitle}</p>
                      </div>

                      {contextualSidebar.additionalHeaderContent && (
                        <div className="mt-1">{contextualSidebar.additionalHeaderContent}</div>
                      )}
                    </div>
                    
                    <div className="relative flex-1 px-4 py-6 sm:px-6">
                      {contextualSidebar.content}
                    </div>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  )
}

export default ContextualSidebar
